<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "app",
  
})
</script>
<template>
	<w-config-provider :locale="getGlobalI18n">
		<router-view />
		<Setings ref="setingsRef" />
		<CloseFull />
		<Noice v-if="isNoice" />
	</w-config-provider>
</template>

<script setup lang="ts" name="app">
import { defineAsyncComponent, computed, ref, onBeforeMount, onMounted, onUnmounted, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useThemeConfig } from '/@/stores/themeConfig';
import other from '/@common/utils/other';
import { Local, Session } from '/@common/utils/storage';
import mittBus from '/@common/utils/mitt';
import setIntroduction from '/@common/utils/setIconfont';
import { storeToRefs } from 'pinia';
import { useUserInfo } from '/@/stores/userInfo';
import { notice } from '/@/api/personal';
import { Message,Modal } from 'winbox-ui-next'
import { useChatStore } from '/@/stores/chat';
import { set } from 'nprogress';
import {useH5Config} from "/@/stores/h5Config";
import {useBasicLayout} from "/@common/hooks/useBasicLayout";
import {appHeight} from "/@common/utils/h5/adapter";
const stores = useUserInfo();
const h5Config = useH5Config();
const { userInfos } = storeToRefs(stores);
const { isMobile } = useBasicLayout();
// 引入组件
const Setings = defineAsyncComponent(() => import('/@common/layout/navBars/breadcrumb/setings.vue'));
const CloseFull = defineAsyncComponent(() => import('/@common/layout/navBars/breadcrumb/closeFull.vue'));
const Noice = defineAsyncComponent(() => import('/@common/layout/noice/index.vue'));
const chatStore = useChatStore();
// 定义变量内容
const { messages, locale } = useI18n();
const setingsRef = ref();
const route = useRoute();
const storesThemeConfig = useThemeConfig();

isMobile.value && appHeight();

const isNoice = computed(() => chatStore.isShowNoice && !isMobile.value)
// 获取全局 i18n
const getGlobalI18n = computed(() => {
	return messages.value[locale.value];
});
// 获取引导页
const getGuide = computed(() => {
	let isGuide = false;
	if (stores.userInfos.userName) {
		if ((Local.get('guide') && Local.get('guide') !== __GUIDE__) || !Local.get('guide')) isGuide = true;
	}
	return isGuide;
});
// 获取余额
const getNoticeFun = async () => {

	// 12月12日 去掉相关请求
	// try {
	// 	if (route.name == 'chat') {
	// 		const res = await notice()
	// 		if(res?.data){
	// 			chatStore.noticeData = res.data
	// 			chatStore.isShowNoice = true
	// 		}
	// 	}
	// } catch (err) {
	// 	throw new Error(err)
	// }
}
// 设置初始化，防止刷新时恢复默认
onBeforeMount(() => {
	// 设置批量第三方 icon 图标
	setIntroduction.cssCdn();
	// 设置批量第三方 js
	setIntroduction.jsCdn();
});
// 页面加载时
onMounted(() => {
	//去掉新年主题
	if(localStorage.getItem('winbox-theme')&& localStorage.getItem('winbox-theme')=='newYear'){
		localStorage.removeItem('winbox-theme')
	}
	// const body = document.body as HTMLElement;
    // body.setAttribute('winbox-theme', 'newYear');
	// localStorage.setItem('winbox-theme','newYear')
	setInterval(() => {
		getNoticeFun()
	},1000 * 60 * 10 )
	nextTick(() => {
		// 监听布局配'置弹窗点击打开
		mittBus.on('openSetingsDrawer', () => {
			setingsRef.value.openDrawer();
		});
		// 获取缓存中的布局配置
		if (Local.get('themeConfig')) {
			storesThemeConfig.setThemeConfig({ themeConfig: Local.get('themeConfig') });
			document.documentElement.style.cssText = Local.get('themeConfigStyle');
		}
		// 获取缓存中的全屏配置
		if (Session.get('isTagsViewCurrenFull')) {
			stores.setCurrenFullscreen(Session.get('isTagsViewCurrenFull'));
		}

    // 设置移动端状态栏高度
    if (localStorage.getItem('statusbarHeight')) {
      h5Config.setStatusBarHeight(+localStorage.getItem('statusbarHeight')! || 0)
    }
	});
});
// 页面销毁时，关闭监听布局配置/i18n监听
onUnmounted(() => {
	mittBus.off('openSetingsDrawer', () => {});
});
// 监听路由的变化，设置网站标题
watch(
	() => route.path,
	() => {
		setTimeout(() => {
      other.useTitle();
    }, 500)
	},
	{
		deep: true,
	}
);
watch(
	() => route.name,
	() => {
		if(route.name == 'chat'){
			getNoticeFun()
		}
	}
);
</script>
